// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LGx3z","controls":"styles_controls__ym4ij","select":"styles_select__2nuLw","text":"styles_text__r3jHo"};